import { Grid } from "@material-ui/core";
import { useCurrentTenant, useErrorContext } from "@qpr/client-library";
import clsx from "clsx";
import BottomMenuIcon from "@qpr/client-api-base/viewcomponents/BottomMenuIcon/BottomMenuIcon";
import BottomMenuIconImage from "@qpr/client-api-base/viewcomponents/BottomMenuIconImage/BottomMenuIconImage";
import BottomNaviTab from "@qpr/client-api-base/viewcomponents/BottomNaviTabs/BottomNaviTab";
import BottomNaviTabs from "@qpr/client-api-base/viewcomponents/BottomNaviTabs/BottomNaviTabs";
import Content from "@qpr/client-api-base/viewcomponents/Content/Content";
import PageContainer from "@qpr/client-api-base/viewcomponents/PageContainer/PageContainer";
import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import useNavitems, { Data } from "@qpr/client-api-base/apihooks/useNavitems";
import {
  getFileApiURL,
  checkIfExternal,
} from "@qpr/client-api-base/utils/url-utils";
import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";

const useStyles = (rtl: boolean, model: string) =>
  makeThemedStyles("LandingPageView", (theme) => {
    return {
      mainContainer: {
        width: "100%",
      },
      gridContainer: {
        opacity: "1",
      },
      contentSection: {
        opacity: "0.9",
        height: "100%",
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
      },
      contentContainer: {
        marginTop: "20.45em",
        marginLeft: "15.54em",
        marginRight: "15.54em",
        color: "rgb(255 255 255)",
      },
      headerContainer: {
        display: "flex",
        flexDirection: "column",
      },
      title: {
        fontSize: "40px",
        maxWidth: "600px",
        lineHeight: "1.24em",
        fontFamily: "Helvetica",
        color: "rgb(255, 255, 255)",
        display: "inherit",
      },
      subTitle: {
        fontSize: "2.05em",
        width: "100%",
        padding: "0",
        paddingTop: "1.82em",
        lineHeight: "1.39em",
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "0.68em",
        fontFamily: "Helvetica",
        fontKerning: rtl ? "normal" : undefined,
        marginRight: rtl ? "0.279em" : undefined,
      },
      quoteContainer: {
        width: "42.5em",
        marginTop: "5.5em",
      },
      quote: {
        fontSize: "2.05em",
      },
      quoteAuthor: {
        fontSize: "1.82em",
        marginTop: "1.25em",
        lineHeight: "2.88em",
        fontFamily: "Helvetica",
      },
    };
  });

const LandingPageView = () => {
  const [index, setIndex] = React.useState(0);

  const navi = useHistory();
  const { t } = useTranslation();
  const [sections, setSections] = useState<Data[]>();
  const tenant = useCurrentTenant();
  const tenantSymbol = tenant.symbol;
  const { setError } = useErrorContext();
  const model = useAppContext((m) => m.model);
  const rtl = useAppContext((m) => m.rtl);

  const styles = useStyles(rtl, model || "")();
  const { error, data, isError } = useNavitems();

  useEffect(() => {
    document.title = tenant.symbol.toLocaleUpperCase();
    setSections(data?.children);
  }, [data, tenant.symbol]);

  return (
    <div className={styles.mainContainer}>
      <PageContainer container>
        <Grid item xs={12} className={styles.gridContainer}>
          <Content>
            <div className={styles.contentSection}>
              <div className={styles.contentContainer}>
                <div className={styles.headerContainer}>
                  <span className={clsx(styles.title, "DinNextLTArabic")}>
                    {t("landingPage.title")}
                  </span>
                  <span className={styles.subTitle}>
                    {t("landingPage.welcome")}
                  </span>
                </div>
                <div className={styles.quoteContainer}>
                  <div className={styles.quote}>{t("landingPage.quote")}</div>
                  <div className={styles.quoteAuthor}>
                    {t(`landingPage.author`)}
                  </div>
                </div>
              </div>
            </div>
          </Content>
        </Grid>
      </PageContainer>
      <BottomNaviTabs
        value={index}
        scrollButtons="auto"
        variant="scrollable"
        onChange={(event, newValue) => {
          setIndex(newValue);
        }}
      >
        {sections?.map((section) => {
          if (typeof section.icon === "string") {
            return (
              <BottomNaviTab
                key={section._id}
                disabled={!section.enabled}
                label={t(`navItems.${section.title}`)}
                onClick={() => {
                  if (checkIfExternal(section.link)) {
                    window.open(section.link, "_blank");
                  } else {
                    navi.push(`/${tenantSymbol}${section.link}`);
                  }
                }}
                icon={
                  <BottomMenuIcon>
                    <BottomMenuIconImage
                      src={`${getFileApiURL(section.icon)}`}
                    />
                  </BottomMenuIcon>
                }
              />
            );
          }
          return null;
        })}
      </BottomNaviTabs>
    </div>
  );
};

export default LandingPageView;
